// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-sprite-animation{position:relative;display:block;overflow:hidden;text-indent:100vw;white-space:nowrap}.h-sprite-animation--fallback{opacity:0;-webkit-transition:opacity 1s;transition:opacity 1s}.h-sprite-animation--fallback-loaded{opacity:1}.h-sprite-animation__node{position:absolute;top:0;left:0;display:block;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
